
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class QuotationItemsGrid extends Serenity.EntityGrid<QuotationItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.QuotationItems'; }
        protected getDialogType() { return QuotationItemsDialog; }
        protected getIdProperty() { return QuotationItemsRow.idProperty; }
        protected getInsertPermission() { return QuotationItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return QuotationItemsRow.localTextPrefix; }
        protected getService() { return QuotationItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);

        }

    }
}